import { useState, useEffect } from 'react';
import Button from '../../../../../core/Button'
import Switch from '../../../../../core/Switch'
import Axios from "axios";
import { Link } from 'react-router-dom';
import Header from '../../../../../component/common/layout/Header';

export default function LandingPage() {

    const [userId, setuserId] = useState('');

    const [survey_title, setSurveyTitle] = useState('')
    const [survey_description, setSurveyDescription] = useState('')

    const [landingchecked, setLandingChecked] = useState(false)
    const landingHandleClick = () => setLandingChecked(!landingchecked)

    const [thankyouchecked, setThankyouChecked] = useState(false)
    const thankyouHandleClick = () => setThankyouChecked(!thankyouchecked)

    const [landingPageType, setlandingPageType] = useState(0)

    const [leadGenchecked, setLeadGenChecked] = useState(false)
    const leadGenHandleClick = () => setLeadGenChecked(!leadGenchecked)
    const [leadGenType, setLeadGenType] = useState(0)
    const [leadGenNumber, setLeadGenNumber] = useState(0)

    const [numberOfquestions, setNumberOfquestions] = useState(0)

    const [sectionchecked, setSectionChecked] = useState(false)
    const sectionHandleClick = () => setSectionChecked(!sectionchecked)
    const [secNumberOfSection, setSecNumberOfSection] = useState(0)
    const [secQuestionPerSection, setSecQuestionPerSection] = useState(0)

    const [scoringchecked, setScoringChecked] = useState(false)
    const scoringHandleClick = () => setScoringChecked(!scoringchecked)



    //Default language code (TODO change) DUMMY DATA 
    const language_code = '22';
    // let suv_setting = '{"sections": {"numberOfSections": "10","questionsPerSection": "2"},"landingPage": {"type": "1"}}';


    const createNewSurvey = () => {

        if ((numberOfquestions == secNumberOfSection * secQuestionPerSection) || (!sectionchecked)) {
            let suv_setting = {
                "numberOfQuestion": numberOfquestions,
                "sections":
                    { "numberOfSections": secNumberOfSection, "questionsPerSection": secQuestionPerSection },
                "landingPage":
                    { "type": landingPageType },
                "leadGenForm": { "leadGenType": leadGenType, "leaadGenNumber": leadGenNumber },
            };

            Axios.post(process.env.REACT_APP_NODE_API_URL + "/survey/addSurvey", {
                language_code: language_code,
                survey_title: survey_title,
                survey_description: survey_description,
                is_landing_page: landingchecked ? '1' : '0',
                is_lead_gen_form: leadGenchecked ? '1' : '0',
                is_sections: sectionchecked ? '1' : '0',
                is_score: scoringchecked ? '1' : '0',
                is_thankyou_page: thankyouchecked ? '1' : '0',
                added_by: userId,
                settings: JSON.stringify(suv_setting),
            }).then((response) => {
                console.log(response)
                if (response.data.response == 200) {
                    alert("successfull! and ID is: " + response.data.survey_id);
                    localStorage.setItem('survey_id', response.data.survey_id);
                    window.location = '/admin/survey/create/qa-builder?survey_id=' + response.data.survey_id;
                } else {
                    alert("Try Again, Error");
                }
            });
        }
        else {
            alert("Number of Question Must be equal to Number of section Multiply Number of Question per section");
        }


    }

    const handleChange = (e, setFn) => {
        setFn(e.target.value);
    };

    useEffect(() => {
        checkToken(localStorage.getItem('token_id'));
    }, [userId])

    const checkToken = async (token_id) => {
        fetch(process.env.REACT_APP_NODE_API_URL + `/auth/getTokenData?token_id=` + token_id)
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    setuserId(result.id);
                    //fetchData();
                },
                (error) => {
                    console.log(error);
                    alert("2 token not verified, or expired, Login Again");
                    window.location = '/';
                }
            )

    }


    //LeadGen Select page type
    const LeadGenSelect = (selectValue) => {
        setlandingPageType(selectValue);
    }



    return (
        <div className='d-flex flex-wrap flex-column main-site-wrapper onb'>
            <Header />
            <div className="main-onboarding-wrapper flex-grow-1">
                <div className="build-onboarding">
                    <div className="onboarding-inner">
                        <div className="heading">
                            <h4>Create your survey</h4>
                        </div>
                        <div className="main-form-wrapper">
                            <div className="name-of-survey field-wrapper">
                                <div className="small-heading">
                                    <div className="name-wrapper">
                                        {/* <h5>Name your survey</h5> */}
                                        <textarea className="form-control" cols={1} placeholder="Survey Title"
                                            value={survey_title}
                                            onChange={(e) => handleChange(e, setSurveyTitle)} />
                                    </div>
                                </div>
                                <textarea className="form-control" cols={1} placeholder="Add description"
                                    value={survey_description}
                                    onChange={(e) => handleChange(e, setSurveyDescription)} />
                            </div>

                            <div className="dropdown-wrap field-wrapper d-flex justify-content-between align-items-center">
                                <div className="small-heading">
                                    <h5>Number of questions </h5>
                                </div>
                                <div className="select-wrap">
                                    <select className="form-control" onInput={e => setNumberOfquestions(e.target.value)}>
                                        <option value="0">0</option>
                                        <option value="16">16</option>
                                        <option value="20">20</option>
                                        <option value="30">30</option>
                                        <option value="40">40</option>
                                        <option value="50">50</option>
                                    </select>
                                </div>
                            </div>
                            <div className="field-wrapper">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="small-heading">
                                        <h5>Sections</h5>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            type='dense'
                                            color='default'
                                            checked={sectionchecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={sectionHandleClick}
                                        />

                                    </div>
                                </div>
                                {(sectionchecked) ?

                                    (<>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="small-heading">
                                                <p>Number of sections</p>
                                            </div>
                                            <div className="select-wrap" onInput={e => setSecNumberOfSection(e.target.value)}>
                                                <select className="form-control">
                                                    <option value="0">0</option>
                                                    <option value="2">2</option>
                                                    <option value="4">4</option>
                                                    <option value="6">6</option>
                                                    <option value="8">8</option>
                                                    <option value="10">10</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="small-heading">
                                                <p>Number of questions per sections</p>
                                            </div>
                                            <div className="select-wrap">
                                                <select className="form-control" onInput={e => setSecQuestionPerSection(e.target.value)}>
                                                    <option value="0">0</option>
                                                    <option value="2">2</option>
                                                    <option value="4">4</option>
                                                    <option value="6">6</option>
                                                    <option value="8">8</option>
                                                    <option value="10">10</option>
                                                </select>
                                            </div>
                                        </div>
                                    </>
                                    ) : null

                                }

                            </div>
                            <div className="field-wrapper">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h5>Scoring</h5>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            type='dense'
                                            color='default'
                                            checked={scoringchecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={scoringHandleClick}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="field-wrapper">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h5>Landing page</h5>
                                    </div>

                                    <div className="switch-wrap">
                                        < Switch
                                            type='dense'
                                            color='default'
                                            checked={landingchecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={landingHandleClick}
                                        />
                                    </div>
                                </div>
                                <div className="custom-checkbox flex-wrap d-flex align-items-center">
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="LandingPageRadio" id="LandingPageRadio1" defaultChecked />
                                        <label className="form-check-label d-flex align-items-center justify-content-center" htmlFor="LandingPageRadio1" onClick={(e) => LeadGenSelect(1)}>
                                            <svg width="196" height="105" viewBox="0 0 196 105" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="91.71" y="0.703857" width="103.709" height="103.709" rx="5" fill="#BBCADF" />
                                                <rect x="0.536133" y="22.3574" width="60.4022" height="4.55866" rx="2.27933" fill="#BBCADF" />
                                                <rect x="0.536133" y="36.0334" width="60.4022" height="4.55866" rx="2.27933" fill="#BBCADF" />
                                                <rect x="0.536133" y="49.7095" width="60.4022" height="4.55866" rx="2.27933" fill="#BBCADF" />
                                                <rect x="0.536133" y="65.6648" width="33.0503" height="9.11732" rx="4.55866" fill="#728095" />
                                            </svg>
                                        </label>
                                        <p><Link to="/survey-landing-page">Simple</Link></p>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="LandingPageRadio" id="LandingPageRadio2" onClick={(e) => LeadGenSelect(2)} />
                                        <label className="form-check-label d-flex align-items-center justify-content-center" htmlFor="LandingPageRadio2">
                                            <svg width="201" height="175" viewBox="0 0 201 175" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="195" height="90" rx="7" fill="#F5F6F8" />
                                                <rect y="106" width="95" height="69" rx="6" fill="#BBCADF" />
                                                <rect x="111" y="120" width="90" height="5" rx="2.5" fill="#BBCADF" />
                                                <rect x="111" y="134" width="90" height="4" rx="2" fill="#BBCADF" />
                                                <rect x="111" y="147" width="90" height="5" rx="2.5" fill="#BBCADF" />
                                                <rect x="8" y="30" width="179" height="5" rx="2.5" fill="#BBCADF" />
                                                <rect x="29" y="44" width="138" height="4" rx="2" fill="#BBCADF" />
                                                <rect x="80" y="57" width="35" height="7" rx="3.5" fill="#728095" />
                                                <rect x="111" y="161" width="26" height="7" rx="3.5" fill="#728095" />
                                            </svg>
                                        </label>
                                        <p><Link to="/detailed-landing-page">Detailed</Link></p>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="LandingPageRadio" id="LandingPageRadio3" onClick={(e) => LeadGenSelect(3)} />
                                        <label className="form-check-label d-flex align-items-center justify-content-center" htmlFor="LandingPageRadio3">
                                            <svg width="199" height="108" viewBox="0 0 199 108" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect width="103" height="104" rx="5" transform="matrix(-1 0 0 1 103 2)" fill="#BBCADF" />
                                                <rect width="27" height="4" rx="2" transform="matrix(-1 0 0 1 150 24)" fill="#BBCADF" />
                                                <rect width="30" height="4" rx="2" transform="matrix(-1 0 0 1 190 24)" fill="#BBCADF" />
                                                <rect width="27" height="5" rx="2.5" transform="matrix(-1 0 0 1 150 37)" fill="#BBCADF" />
                                                <rect width="28" height="5" rx="2.5" transform="matrix(-1 0 0 1 189 37)" fill="#BBCADF" />
                                                <rect width="28" height="5" rx="2.5" transform="matrix(-1 0 0 1 189 51)" fill="#BBCADF" />
                                                <rect width="27" height="5" rx="2.5" transform="matrix(-1 0 0 1 150 51)" fill="#BBCADF" />
                                                <rect width="33" height="6" rx="3" transform="matrix(-1 0 0 1 156 78)" fill="#728095" />
                                                <rect width="27" height="4" rx="2" transform="matrix(-1 0 0 1 150 65)" fill="#BBCADF" />
                                                <rect x="115" y="2" width="82" height="104" rx="5" stroke="#E6EAEE" stroke-width="3" />
                                            </svg>

                                        </label>
                                        <p>
                                            <Link to="/simple-form-landing-page">Simple with form</Link>
                                        </p>
                                    </div>
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="LandingPageRadio" id="LandingPageRadio4" onClick={(e) => LeadGenSelect(4)} />
                                        <label className="form-check-label d-flex align-items-center justify-content-center" htmlFor="LandingPageRadio4">
                                            <svg width="104" height="64" viewBox="0 0 104 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M34.8344 6.83597C35.2062 6.46413 35.5012 6.02269 35.7024 5.53685C35.9037 5.05101 36.0073 4.53029 36.0073 4.00442C36.0073 3.47855 35.9037 2.95783 35.7024 2.47199C35.5012 1.98615 35.2062 1.54471 34.8344 1.17287C34.4625 0.801022 34.0211 0.506058 33.5352 0.304817C33.0494 0.103576 32.5286 -3.91802e-09 32.0028 0C31.4769 3.91802e-09 30.9561 0.103576 30.4703 0.304817C29.9844 0.506058 29.543 0.801022 29.1711 1.17287L1.17499 29.1684C0.802535 29.54 0.507032 29.9813 0.305408 30.4672C0.103785 30.9531 0 31.4739 0 32C0 32.5261 0.103785 33.0469 0.305408 33.5328C0.507032 34.0187 0.802535 34.46 1.17499 34.8316L29.1711 62.8271C29.9221 63.5781 30.9407 64 32.0028 64C33.0648 64 34.0834 63.5781 34.8344 62.8271C35.5854 62.0762 36.0073 61.0576 36.0073 59.9956C36.0073 58.9335 35.5854 57.915 34.8344 57.164L9.66182 32L34.8344 6.83597ZM69.1656 6.83597C68.4146 6.085 67.9928 5.06646 67.9928 4.00442C67.9928 2.94238 68.4146 1.92384 69.1656 1.17287C69.9166 0.421892 70.9352 2.74108e-08 71.9973 0C73.0593 -2.74107e-08 74.0779 0.421892 74.8289 1.17287L102.825 29.1684C103.197 29.54 103.493 29.9813 103.695 30.4672C103.896 30.9531 104 31.4739 104 32C104 32.5261 103.896 33.0469 103.695 33.5328C103.493 34.0187 103.197 34.46 102.825 34.8316L74.8289 62.8271C74.0779 63.5781 73.0593 64 71.9973 64C70.9352 64 69.9166 63.5781 69.1656 62.8271C68.4146 62.0762 67.9928 61.0576 67.9928 59.9956C67.9928 58.9335 68.4146 57.915 69.1656 57.164L94.3382 32L69.1656 6.83597Z" fill="#BBCADF" />
                                            </svg>
                                        </label>
                                        <p><Link to="/widget-form-landing-page">Upload Custom</Link></p>
                                    </div>
                                </div>
                                <div className="italic-text">
                                    <p><i>You can always change it later</i></p>
                                </div>
                            </div>
                            <div className="field-wrapper">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="small-heading">
                                        <h5>Lead-gen form</h5>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            type='dense'
                                            color='default'
                                            checked={leadGenchecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={leadGenHandleClick}
                                        />
                                    </div>
                                </div>
                                {(leadGenchecked) ?
                                    (<>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <div className="small-heading">
                                                {/* <p>Show after Question</p> */}
                                                <div className="select-wrap show-after">
                                                    <select className="form-control" onInput={e => setLeadGenType(e.target.value)}>
                                                        <option value="beforeSection">Before Section</option>
                                                        <option value="beforeQuestion">Before Question</option>
                                                        <option value="afterSection">After Section</option>
                                                        <option value="afterQuestion">After Question</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="select-wrap show-after">
                                                <select className="form-control" onInput={e => setLeadGenNumber(e.target.value)}>
                                                    <option value="0">0</option>
                                                    <option value="21">21</option>
                                                    <option value="4">4</option>
                                                    <option value="6">6</option>
                                                    <option value="8">8</option>
                                                    <option value="10">10</option>
                                                </select>
                                            </div>
                                        </div>
                                    </>

                                    ) : null}


                                {/* <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="small-heading">
                                        <div className="select-wrap show-after">
                                        <select className="form-control">
                                            <option>2</option>
                                            <option>4</option>
                                            <option>6</option>
                                            <option>8</option>
                                            <option>10</option>
                                        </select>
                                    </div>
                                    </div>
                                    <div className="select-wrap show-after">
                                        <select className="form-control">
                                            <option>2</option>
                                            <option>4</option>
                                            <option>6</option>
                                            <option>8</option>
                                            <option>10</option>
                                        </select>
                                    </div>
                                </div> */}

                                {/* <div className="d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <p>Show after question number</p>
                                    </div>
                                    <div className="select-wrap">
                                        <select className="form-control">
                                            <option>2</option>
                                            <option>4</option>
                                            <option>6</option>
                                            <option>8</option>
                                            <option>10</option>
                                        </select>
                                    </div>
                                </div> */}
                            </div>
                            <div className="field-wrapper">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="small-heading">
                                        <h5>Thank you page</h5>
                                    </div>
                                    <div className="switch-wrap">
                                        < Switch
                                            type='dense'
                                            color='default'
                                            checked={thankyouchecked}
                                            disabled={false}
                                            label=''
                                            fill={false}
                                            rtl={false}
                                            leftPosition={false}
                                            className='SwitchCustom'
                                            onClick={thankyouHandleClick}
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="button-wrap d-flex mt-4">
                            <Button className={"theme-btn"}
                                type="default"
                                view="filled"
                                color="primary"
                                text="Create survey"
                                onClick={createNewSurvey}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
